import { render, staticRenderFns } from "./report.vue?vue&type=template&id=97c2ca8c&scoped=true&"
import script from "./report.vue?vue&type=script&lang=js&"
export * from "./report.vue?vue&type=script&lang=js&"
import style1 from "./report.vue?vue&type=style&index=1&id=97c2ca8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c2ca8c",
  null
  
)

export default component.exports